<template>
  <div class="menu">
    <div class="main_content mc-flex">
        <!-- 全部商品分类 -->
        <div class="menu-nav mc-relative">
            <!-- 菜单栏 -->
            <div class="mc-flex mc-items-center mc-pl-15 yellow-bg mc-cursor-default">
                <img src="@/assets/images/menu.png" class="mc-mr-10" width="16px" height="14px" alt />全部分类商品
            </div>
            <!-- 一级分类 -->
            <div class="menu-nav-box mc-absolute" :class="{'menu-nav-box-show': firstNav}">
                <ul class="first-nav">
                    <li
                      class="first-nav-li mc-flex mc-items-center mc-flex-justify-between"
                      v-for="(item, index) in categoryList" :key="index"
                      v-if="index < 11">
                        <div class="title-nav mc-ellipsis">
                            <div class="mc-flex mc-items-center">
                                <router-link
                                  class="mc-flex mc-items-center oneMenu"
                                  v-for="(oneItem, oneIndex) in item.groupedCats" :key="oneIndex"
                                  :to="`/search?type=category&categoryId=${oneItem.code}`">
                                    {{ oneItem.name }}
                                    <!-- {{ oneItem.name }}({{ oneItem.productCount }}) -->
                                </router-link>
                            </div>
                        </div>
                        <img src="@/assets/images/menu-right.png" width="7px" height="11px" alt />

                        <!-- 二级分类 -->
                        <ul class="second-nav mc-absolute white-bg">
                            <li v-for="(twoItem, twoIndex) in item.subCats" :key="twoIndex" class="mc-flex mc-items-start">
                                <div class="mc-flex mc-items-center mc-flex-justify-end mc-bold gray3-text mc-mr-20 second-nav-title mc-flex-shrink mc-ellipsis">
                                    <router-link :to="`/search?type=category&secCategoryId=${twoItem.code}`" class="second-nav-title-text gray3-text">
                                      {{ twoItem.name }}({{ twoItem.productCount }})
                                    </router-link>
                                    <img src="@/assets/images/menu-right_default.png" class="mc-ml-10" width="7px" height="11px" alt />
                                </div>

                                <!-- 三级分类 -->
                                <div class="mc-flex mc-flex-wrap">
                                    <router-link
                                      class="gray9-text mc-mr-20"
                                      v-for="(threeItem, threeIndex) in twoItem.subCats" :key="threeIndex"
                                      :to="`/search?type=category&thirCategoryId=${threeItem.code}`">
                                        {{ threeItem.name }}({{ threeItem.productCount }})
                                    </router-link>
                                </div>
                                <!-- 三级分类 end -->
                            </li>
                        </ul>
                        <!-- 二级分类 end -->
                    </li>
                </ul>
            </div>
            <!-- 一级分类 end -->
        </div>

        <!-- 导航菜单 -->
        <div class="menu-list">
            <el-menu mode="horizontal" class="menu-list-sub">
                <el-menu-item index="1"><router-link to="/home" class="yellow-hover">首页</router-link></el-menu-item>
                <el-menu-item index="2"><router-link to="/search?type=spot" class="yellow-hover">现货专区</router-link></el-menu-item>
                <el-menu-item index="3"><router-link to="/brand" class="yellow-hover">品牌馆</router-link></el-menu-item>
                <el-menu-item index="4"><router-link to="/solution" class="yellow-hover">解决方案</router-link></el-menu-item>
                <el-submenu index="5" :popper-append-to-body="false">
                    <template slot="title">合作洽谈</template>
                    <el-menu-item index="5-1"><router-link to="/inquiry" class="yellow-hover">我要咨询</router-link></el-menu-item>
                    <el-menu-item index="5-2"><router-link to="/cooperate" class="yellow-hover">我要合作</router-link></el-menu-item>
                </el-submenu>
            </el-menu>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["firstNav"],
  data() {
    return {
      categoryList: this.$store.state.menuList,
    };
  },

  // components: {},

  // computed: {},

  mounted() {
    this.getCategory();
  },

  methods: {
    async getCategory() {
        if(!this.categoryList){
            await this.$store.dispatch("getMenuList");
            this.categoryList = this.$store.state.menuList;
        };
    },
  },
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";

.menu {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: @4a;
  border-bottom: 2px solid @yellow;
  /* 全部商品分类 */
  .menu-nav {
    width: 200px;
    a {
      &:hover {
        text-decoration: underline;
      }
    }
    &:hover {
      .menu-nav-box {
        display: block;
      }
    }
    .menu-nav-box {
      &.menu-nav-box-show {
        display: block;
      }
      display: none;
      z-index: 10001;
      background: @4a;
      color: @white;
      .first-nav {
        width: 200px;
        li.first-nav-li {
          width: 100%;
          padding: 0 15px;
          height: 40px;
          line-height: 40px;
          cursor: default;
          &:hover {
            background: @yellow;
            .second-nav {
              display: block;
            }
          }
          .title-nav {
            width: 100%;
            overflow: hidden;
            .oneMenu {
              color: @white;
              margin-right: 10px;
            }
          }
          .second-nav {
            display: none;
            top: 0;
            left: 200px;
            width: 1000px;
            height: 440px;
            overflow: hidden;
            overflow-y: auto;
            li {
              line-height: 36px;
              font-size: 12px;
              color: @gray3;
              border-bottom: 1px solid @eee;
              padding: 3px 0;
              margin: 0 15px;
              &:last-child {
                border-bottom: none;
              }
              .second-nav-title {
                width: 150px;
                height: 36px;
                white-space: normal;
                .second-nav-title-text {
                  line-height: 18px;
                  text-align: right;
                }
              }
            }
          }
          span {
            i {
              height: 40px;
              line-height: 36px;
              display: inline-block;
              font-style: normal;
              color: @white;
            }
            &:last-child {
              i {
                display: none;
              }
            }
          }
        }
      }
    }
  }
  /* 导航菜单 */
  /deep/.menu-list {
      a {
        display: block;
        color: @white;
        &.router-link-active {
          color: @yellow;
        }
      }
      .menu-list-sub {
        background-color: transparent;
        .el-menu-item {
          height: 38px;
          line-height: 38px;
          margin-left: 80px;
          padding: 0;
          border-bottom: none;
          &:hover {
            background-color: transparent;
          }
          &:focus {
            background-color: transparent;
          }
        }
        .el-submenu {
          margin-left: 80px;
          .el-submenu__title {
            height: 38px;
            line-height: 38px;
            padding: 0;
            background: none;
            color: @white;
          }
          .el-menu {
            min-width: 0;
            margin-top: 0;
            padding: 0;
            background: @4a;
            .el-menu-item {
              min-width: 0;
              height: 36px;
              line-height: 36px;
              margin-left: 0;
              background-color: transparent;
              a {
                padding: 0 10px;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue